import { ComponentWithAs, Tag, TagProps, forwardRef } from '@chakra-ui/react';

export const TagSuggestion: React.FC<TagProps> = forwardRef<
  TagProps,
  ComponentWithAs<'span', TagProps>
>((props, ref) => (
  <Tag
    _active={{ backgroundColor: 'primary.200' }}
    _hover={{ backgroundColor: 'primary.100' }}
    borderRadius="full"
    colorScheme="primary"
    backgroundColor="primary.50"
    cursor="pointer"
    marginX={1}
    marginBottom={2}
    size="lg"
    fontWeight={400}
    ref={ref}
    {...props}
  />
));
